export const apiHost = process.env.VUE_APP_API_HOST;
// export const googleApiKey = process.env.VUE_APP_GOOGLE_API_KEY;
// export const googleAnalyticsKey = process.env.VUE_APP_GOOGLE_ANALYTICS_KEY;

export const headerPost = {
	headers: {
		'Content-Type': 'application/x-www-form-urlencoded',
	},
	auth: {
		username: process.env.VUE_APP_API_USERNAME,
		password: process.env.VUE_APP_API_PASSWORD
	}
}